export default __webpack_public_path__ + "static/117-e5dbdc5be27277e0931c1b3a82ca4e1a.jpg";